var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-section-header"},[_c('h2',{staticClass:"c-section-header__title"},[_vm._v(_vm._s(_vm.title))]),(_vm.$slots.right)?[_c('div',{staticClass:"c-section-header__right"},[_vm._t("right")],2)]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }